/**
 * Centralized language registry for the frontend.
 * Single source of truth for all supported UI languages.
 *
 * To add a new language, add an entry to the LANGUAGES array below.
 * All derived maps (languageMap, codeToLanguageMap, nativeLabels) are computed automatically.
 */

const LANGUAGES = [
  { code: 'en', name: 'English', nativeLabel: 'English' },
  { code: 'es', name: 'Spanish', nativeLabel: 'Español' },
  { code: 'zh', name: 'Mandarin', nativeLabel: '中文' },
  { code: 'zh-TW', name: 'Traditional Chinese', nativeLabel: '繁體中文' },
  { code: 'de', name: 'German', nativeLabel: 'Deutsch' },
  { code: 'sv', name: 'Swedish', nativeLabel: 'Svenska' },
  { code: 'ar', name: 'Arabic', nativeLabel: 'العربية' },
  { code: 'pt', name: 'Portuguese', nativeLabel: 'Português' },
  { code: 'hi', name: 'Hindi', nativeLabel: 'हिन्दी' },
  { code: 'it', name: 'Italian', nativeLabel: 'Italiano' },
  { code: 'vi', name: 'Vietnamese', nativeLabel: 'Tiếng Việt' },
  { code: 'pl', name: 'Polish', nativeLabel: 'Polski' },
  { code: 'tr', name: 'Turkish', nativeLabel: 'Türkçe' },
  { code: 'ro', name: 'Romanian', nativeLabel: 'Română' },
  { code: 'fr', name: 'French', nativeLabel: 'Français' },
  { code: 'tl', name: 'Tagalog', nativeLabel: 'Tagalog' },
  { code: 'ja', name: 'Japanese', nativeLabel: '日本語' },
];

// { English: 'en', Spanish: 'es', Japanese: 'ja', ... }
export const languageMap = Object.fromEntries(LANGUAGES.map(l => [l.name, l.code]));

// { en: 'English', es: 'Spanish', ja: 'Japanese', ... }
export const codeToLanguageMap = Object.fromEntries(LANGUAGES.map(l => [l.code, l.name]));

// { English: 'English', Spanish: 'Español', Japanese: '日本語', ... }
export const nativeLabels = Object.fromEntries(LANGUAGES.map(l => [l.name, l.nativeLabel]));
